import { render } from "./EditarAcreditadoView.vue?vue&type=template&id=253a1c04&ts=true"
import script from "./EditarAcreditadoView.vue?vue&type=script&lang=ts"
export * from "./EditarAcreditadoView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__